require('./age-gate/age-gate.scss');
var BaseViews = require('../base');
var Button = require('treeline-shared-components/button.js');
var SpinnerButton = require('treeline-shared-components/spinner-button');

var lsCache = require('lscache');

var AgeGate = BaseViews.LayoutView.extend({
    template: require('./age-gate/age-gate.html'),
    className: 'fmcy-age-gate',
    initialize: function (options) {
        var self = this;
        this.options = _.defaults(
            options || {},
            {
                _appChannel: null
            }
        );
        this.deliveryModel = this.options._appChannel.request('cart:get:delivery:model');
        this.deliveryAddressModel = this.deliveryModel.get('cartDeliveryAddressModel');
    },
    ui: {
        ageGateTitle: '.fmcy-age-gate-title',
        ageGateButtonBar: '.fmcy-age-gate-button-bar'
    },
    regions : {
      noButtonRegion: '.fmcy-no-button-region',
      yesButtonRegion: '.fmcy-yes-button-region'
    },
    _renderYesButton: function () {
        var self = this;
        var yesButton = new SpinnerButton.SpinnerButton({
            label: 'Yes',
            multiClick: false,
            classNames: 'fmcy-yes-btn',
            theme: SpinnerButton.THEMES.PRIMARY,
            size: SpinnerButton.SIZES.LARGE,
            onClickedCallback: function () {
                self.trigger('yes:clicked');
            }
        });
        this.yesButtonRegion.show(yesButton);
    },
    _renderNoButton: function () {
        var self = this;
        var noButton = new SpinnerButton.SpinnerButton({
            label: 'No',
            multiClick: false,
            classNames: 'fmcy-no-btn',
            theme: SpinnerButton.THEMES.PRIMARY,
            size: SpinnerButton.SIZES.LARGE,
            onClickedCallback: function () {
                self._renderNoButtonClickedMessage();
            }
        });
        this.noButtonRegion.show(noButton);
    },
    _renderNoButtonClickedMessage: function () {
        this.ui.ageGateTitle.html('Sorry you must be 19 to enter');
        this.ui.ageGateButtonBar.css('display', 'none');
    },
    onRender: function () {
        this._renderYesButton();
        this._renderNoButton();
    }
});
module.exports = AgeGate;



/** WEBPACK FOOTER **
 ** ./assets/js/common/entry-flow/age-gate.js
 **/